import { render, staticRenderFns } from "./CardBagDetail.vue?vue&type=template&id=1753081c&scoped=true&"
import script from "./CardBagDetail.vue?vue&type=script&lang=js&"
export * from "./CardBagDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardBagDetail.vue?vue&type=style&index=0&id=1753081c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753081c",
  null
  
)

export default component.exports